export const currencies = [
	'AUD',
	'BGN',
	'BRL',
	'CAD',
	'CHF',
	'CNY',
	'CZK',
	'DKK',
	'EUR',
	'GBP',
	'HKD',
	'HUF',
	'IDR',
	'INR',
	'ISK',
	'JPY',
	'KRW',
	'MXN',
	'MYR',
	'NOK',
	'NZD',
	'PHP',
	'PLN',
	'RON',
	'SEK',
	'SGD',
	'THB',
	'TRY',
	'USD',
	'ZAR',
] as const

export type Theme = 'system' | 'light' | 'dark'
export type Currency = (typeof currencies)[number]
export type Preferences = {
	readonly theme: Theme
	readonly currency: Currency
	readonly liveRates: boolean
}
export type MathPreferences = Pick<Preferences, 'currency' | 'liveRates'>
